define(["data/config", "componentClasses/popover"], function(config, Popover) {
    return {
        name: "popover",
        defaultParameters: {
            persist: false,
            wrap: false
        },
        apply: function($element, params) {
            params.origin = $element;

            $element.on("click", function(ev) {
                ev.preventDefault();
                ev.stopPropagation();
                var popover = new Popover(params);
                popover._clearAllPopovers();
                popover.place();
            });
        }
    };
});
